export default "__VITE_ASSET__fSdA6DSp__"